import { useQuery } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';
import type { ListTargetsResponse, MaskedOTPConfig } from '@erp/rpc';

export function useSmsNumber() {
  return useQuery(orpc.otp.getSmsNumber.queryOptions({ input: {} }));
}

export interface UseOTPTargetsListOptions {
  limit?: number;
  offset?: number;
}

export function useOTPTargetsList({
  limit = 100,
  offset = 0,
}: UseOTPTargetsListOptions = {}) {
  const query = useQuery(
    orpc.otp.listTargets.queryOptions({ input: { limit, offset } }),
  );

  const configs = query.data?.configs ?? [];
  const pagination = query.data?.pagination;

  return {
    ...query,
    configs,
    pagination,
  } satisfies typeof query & {
    data?: ListTargetsResponse;
    configs: MaskedOTPConfig[];
    pagination: ListTargetsResponse['pagination'] | undefined;
  };
}
